import { render, staticRenderFns } from "./ProjectCalendar.vue?vue&type=template&id=a808a1cc&"
import script from "./ProjectCalendar.vue?vue&type=script&lang=js&"
export * from "./ProjectCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a808a1cc')) {
      api.createRecord('a808a1cc', component.options)
    } else {
      api.reload('a808a1cc', component.options)
    }
    module.hot.accept("./ProjectCalendar.vue?vue&type=template&id=a808a1cc&", function () {
      api.rerender('a808a1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectCalendar.vue"
export default component.exports